<div class="cat-big-card" (click)="onCategoryClick(cat)">
  <div class='d-flex flex-column c-pointer'>
    <!-- <img class="cat-img  border rounded" [src]="cat?.categoryInfo?.mainPic || 'assets/images/logo.png'"> -->
    <div class="cat-img border rounded" [attr.style]="'background-image:url(' + (cat?.categoryInfo?.mainPic || cart?.$truck?.logoPic || cart?.$truck?.mainPic || 'assets/images/logo.png') + ')'"></div>
    <div class="cat-title">
      <h3>{{cat.categoryInfo.title | iknLocalized}}</h3>
    </div>
  </div>
</div>
